import styled from "styled-components"

import {H6} from "@irati/ui/src/Typography"

export const FlexStartH6 = styled(H6)`
  align-self: flex-start;
`
